<template>
  <div>
    <section>
      <div class="table-hd">健康分析</div>
      <div class="table">
        <div class="th">
          <div class="key">项目</div>
          <div class="val">指数</div>
          <div class="key">状态</div>
          <div class="val">时间</div>
        </div>

        <div v-if="health.firstHrv.state" class="tr">
          <div class="key">HRV指数</div>
          <div class="val">{{ health.firstHrv.hrvIndex+'ms' || '--' }}</div>
          <div class="key">
            <span v-if="health.firstHrv.state==='string'||health.firstHrv.state===''||health.firstHrv.state==='0'||health.firstHrv.state===null">
              正常
            </span>
            <span v-else-if="!health.firstHrv.normal" class="abnormal"> 异常</span>
            <span v-else>正常</span>
          </div>
          <div class="val">{{ dateFormat(health.firstHrv.testTime, 'MM-DD') || '--' }}</div>
        </div>
        <div v-if="health.firstSleepActivity.state" class="tr">
          <div class="key">呼吸暂停</div>
          <div class="val">{{ health.firstSleepActivity.breathPause || '--' }}</div>
          <div class="key">
            <span v-if="health.firstSleepActivity.state==='string'||health.firstSleepActivity.state===''||health.firstSleepActivity.state==='0'||health.firstSleepActivity.state===null">
              正常
            </span>
            <span v-else-if="!health.firstSleepActivity.normal" class="abnormal"> 异常</span>
            <span v-else>正常</span>
          </div>
          <div class="val">{{ dateFormat(health.firstSleepActivity.testTime, 'MM-DD') || '--' }}}}</div>
        </div>
        <div v-if="health.firstBloodPressure.state" class="tr">
          <div class="key">血压</div>
          <div class="val">{{ health.firstBloodPressure.sbp+'/'+health.firstBloodPressure.dbp+'mmHg' || '--' }}</div>
          <div class="key">
            <span v-if="strChangeArr( health.firstBloodPressure.state2)[0]!=='正常'||strChangeArr( health.firstBloodPressure.state2)[1]!=='正常'" class="abnormal">
              <span v-if="strChangeArr( health.firstBloodPressure.state2)[0]!=='正常'">收缩压{{ strChangeArr( health.firstBloodPressure.state2)[0] }}</span><br>
              <span v-if="strChangeArr( health.firstBloodPressure.state2)[1]!=='正常'">舒张压{{ strChangeArr( health.firstBloodPressure.state2)[1] }}</span>
            </span>
            <span v-else>
              {{ strChangeArr( health.firstBloodPressure.state2)[0] }}
            </span>
          </div>
          <div class="val">{{ dateFormat(health.firstBloodPressure.testTime, 'MM-DD') || '--' }}</div>
        </div>
        <div v-if="health.firstBloodSugar.bs" class="tr">
          <div class="key">血糖</div>
          <div class="val">{{ health.firstBloodSugar.bs+'mmol/L' || '--' }}</div>
          <div class="key">
            <span v-if="strChangeArr( health.firstBloodSugar.state2)[0]!=='正常'" class="abnormal">
              {{ health.firstBloodSugar.state }}
            </span>
            <span v-else>
              {{ health.firstBloodSugar.state }}
            </span>
          </div>
          <div class="val">{{ dateFormat(health.firstBloodSugar.testTime, 'MM-DD') || '--' }}</div>
        </div>

        <div v-if="health.firstHeartBeat.state" class="tr">
          <div class="key">心率</div>
          <div class="val">{{ health.firstHeartBeat.hb+'bpm' || '--' }}</div>
          <div class="key">
            <span v-if="strChangeArr( health.firstHeartBeat.state2)[0]!=='正常'" class="abnormal">
              {{ strChangeArr( health.firstHeartBeat.state2)[0] }}
            </span>
            <span v-else>
              {{ strChangeArr( health.firstHeartBeat.state2)[0] }}
            </span>
          </div>
          <div class="val">{{ dateFormat(health.firstHeartBeat.testTime, 'MM-DD') || '--' }}</div>
        </div>
        <div v-if="health.firstHeartState.state" class="tr">
          <div class="key">心电</div>
          <div class="val">{{ health.firstHeartState.heartRate || '--' }}</div>
          <div class="key">
            <span v-if="strChangeArr( health.firstHeartState.state2)[0]!=='正常'" class="abnormal">
              {{ strChangeArr( health.firstHeartState.state2)[0] }}
            </span>
            <span v-else>
              {{ strChangeArr( health.firstHeartState.state2)[0] }}
            </span>
          </div>
          <div class="val">{{ dateFormat(health.firstHeartState.testTime, 'MM-DD') || '--' }}</div>
        </div>

        <div v-if="health.firstSleepActivity.state" class="tr">
          <div class="key">心脏负荷</div>
          <div class="val">{{ health.firstSleepActivity.heartLoad+'pi' || '--' }}</div>
          <div class="key">
            <span v-if="health.firstSleepActivity.heartLoadState!=='正常'" class="abnormal">
              {{ health.firstSleepActivity.heartLoadState }}
            </span>
            <span v-else>
              {{ health.firstSleepActivity.heartLoadState }}
            </span>
          </div>
          <div class="val">{{ dateFormat(health.firstSleepActivity.testTime, 'MM-DD') || '--' }}</div>
        </div>

        <div v-if="health.firstBloodOxygen.state" class="tr">
          <div class="key">血氧</div>
          <div class="val">{{ health.firstBloodOxygen.bo+'%' || '--' }}</div>
          <div class="key">
            <span v-if="strChangeArr(health.firstBloodOxygen.state2)[0]!=='正常'" class="abnormal">
              {{ strChangeArr(health.firstBloodOxygen.state2)[0] }}
            </span>
            <span v-else>
              {{ strChangeArr(health.firstBloodOxygen.state2)[0] }}
            </span>
          </div>
          <div class="val">{{ dateFormat(health.firstBloodOxygen.testTime, 'MM-DD') || '--' }}</div>
        </div>

        <div v-if="health.firstArteriosclerosis.state" class="tr">
          <div class="key">动脉硬化指数</div>
          <div v-if="health.firstArteriosclerosis.asi!==0" class="val">{{ health.firstArteriosclerosis.asi+'mL/mmHg'|| '--' }}</div>
          <div v-else class="val">{{ health.firstArteriosclerosis.api+'/'+health.firstArteriosclerosis.avi+'\nmL/mmHg'|| '--' }}</div>
          <div class="key">
            <span v-if="strChangeArr(health.firstArteriosclerosis.state2)[0]!=='正常'" class="abnormal">
              {{ strChangeArr(health.firstArteriosclerosis.state2)[0] }}
            </span>
            <span v-else>
              {{ strChangeArr(health.firstBloodOxygen.state2)[0] }}
            </span>
          </div>
          <div class="val">{{ dateFormat(health.firstBloodOxygen.testTime, 'MM-DD') || '--' }}</div>
        </div>
      </div>
    </section>

    <section class="analysis">
      <div id="analysis" class="bd" />
    </section>

    <!-- <section class="desc">
      <div class="title">您的风险等级为：<span class="result">高</span></div>
      <div class="desc-bd">
        <div>本次风险程度为：85.44</div>
        <div>您的最佳状态为：67.34</div>
        <div>通过努力可降为：67.34</div>
        <div>人群平均风险为：67.34</div>
      </div>
    </section>  -->

    <section class="guide">
      <div class="hd">健康指导</div>
      <div class="bd">饮食建议<br>
        适量摄入蛋白质，多吃含钾、钙丰富而含钠低的食品，限制盐的摄入量，多吃新鲜蔬菜，水果。
        <br>运动建议<br>
        夏季户外锻炼应该选择在清晨或者黄昏。夏季太阳紫外线很强，容易晒伤肌肤，也会容易造成中暑等现象。所以，高血压病人更要注意避暑降温。
      </div>
    </section>

  </div>
</template>

<script>
import { fetchReport } from '@/api/health'
import { fetchScore } from '@/api/health'
import { dateFormat, dateISO, strChangeArr } from '@/utils/tool'

var echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/line')

export default {
  data() {
    return {
      dateFormat,
      strChangeArr,
      type: { sbp: '收缩压', dbp: '舒张压', firstHeartBeat: '心率', firstBloodSugar: '血糖', SleepQuality: '睡眠' },
      health: {
        step: {},
        bp: {},
        bs: {},
        sleep: {},
        firstHrv: {},
        firstSleepActivity: {},
        firstBloodPressure: {},
        firstBloodOxygen: {},
        firstHeartBeat: {},
        firstBloodSugar: {},
        firstHeartState: {},
        firstArteriosclerosis: {},
        firstWalkStep: {}
      },
      xScore: [],
      yScore: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      fetchReport().then(res => {
        res.data.data.firstBloodPressure = res.data.data.firstBloodPressure ? res.data.data.firstBloodPressure : {}
        res.data.data.firstHrv = res.data.data.firstHrv ? res.data.data.firstHrv : {}
        res.data.data.firstSleepActivity = res.data.data.firstSleepActivity ? res.data.data.firstSleepActivity : {}
        res.data.data.firstHeartState = res.data.data.firstHeartState ? res.data.data.firstHeartState : {}
        res.data.data.firstBloodOxygen = res.data.data.firstBloodOxygen ? res.data.data.firstBloodOxygen : {}
        res.data.data.firstHeartBeat = res.data.data.firstHeartBeat ? res.data.data.firstHeartBeat : {}
        res.data.data.firstBloodSugar = res.data.data.firstBloodSugar ? res.data.data.firstBloodSugar : {}
        res.data.data.firstWalkStep = res.data.data.firstWalkStep ? res.data.data.firstWalkStep : null
        res.data.data.firstArteriosclerosis = res.data.data.firstArteriosclerosis ? res.data.data.firstArteriosclerosis : {}
        res.data.data.firstBMI = res.data.data.firstBMI ? res.data.data.firstBMI : null
        this.health = res.data.data
      })
      const date = new Date()
      date.setDate(date.getDate() - 7)
      fetchScore({
        sTime: dateISO(`${dateFormat(date, 'YYYY/MM/DD')} 00:00:01`),
        eTime: dateISO(`${dateFormat(new Date(), 'YYYY/MM/DD')} 23:59:59`),
        order: 0
      }).then(res => {
        const data = res.data.data
        this.score = data.lastHealthScore.score
        data.healthScoreListOfStartEndTime.reverse()
        data.healthScoreListOfStartEndTime.forEach(item => {
          this.xScore.push(dateFormat(item.createTime, 'M-D'))
          this.yScore.push(item.score)
        })
        this.chart({
          dom: 'analysis',
          color: '#FCA251',
          xData: this.xScore,
          Ydata: this.yScore
        })
      })
    },
    chart(data) {
      var myChart = echarts.init(document.getElementById(data.dom))
      myChart.setOption({
        grid: {
          left: '4%', // 图表距边框的距离
          right: '4%',
          top: '12%',
          bottom: '7%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: data.xData,
          axisLine: {
            lineStyle: {
              color: '#ccc',
              type: 'dashed'
            }
          },
          axisLabel: {
            color: '#333'
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          axisLabel: {
            color: '#333'
          }
        },
        series: [{
          data: data.Ydata,
          type: 'line',
          lineStyle: {
            color: data.color
          },
          itemStyle: {
            color: data.color
          }
        }]
      })
    }
  }
}
</script>

<style scoped lang="scss">

    .table-hd {
        color: #999;
        padding: 10px 15px;
    }
    .table {
            background: #fff;
        .th, .tr {
            display: flex;
            text-align: center;
            line-height: 32px;
            align-items:center;

        }
        .th {
            background: #FFF7E7;
            color: #666;
            border-bottom: 1px solid #ececec;
            line-height: 44px;
        }
        .tr {
            padding: 6px 0;
            .key, .val {
                border-right: 1px solid #ddd;
                font-size: 12px;
            }
        }
        .tr:nth-child(even) {
            background: #F9F9F9
        }
        .key {
            width: 25%;
        }
        .key:nth-last-child(1) {
            border: none;
        }
        .val {
            flex: 1;
        }
    }
    .analysis {
        margin-top: 10px;
        .bd {
            height: 200px;
            background: #fff;
            border-radius: 5px;
        }
    }
    .desc {
      background: #fff;
      margin-top: 10px;
      padding: 15px;
      .title {
        font-weight: bold;
      }
      .result {
        color: #DC3526;
      }
      .desc-bd {
        display: flex;
        flex-wrap: wrap;
        line-height: 2;
        margin-top: 5px;
        div:nth-child(odd) {
          margin-right: 30px
        }
      }
    }
    .guide {
      .hd {
        color: #999;
        padding: 15px 15px 10px;
      }
      .bd {
        background: #fff;
        padding: 15px;
      }
    }
</style>
